var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:{'rotate':_vm.rotate},attrs:{"xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},[_c('polygon',{attrs:{"fill":_vm.fill,"points":"21.9,12 2.1,0.6 2.1,23.4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }